import React from 'react'
import adventure from "./../assets/adventure.svg"

export default function TopRightImage () {
  return (
    <img src={adventure} alt="adventure" className="adventure"/>
  )
}